/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */

export const AI_PLANNER_EMBEDDED_CONFLUENCE_SOURCE: any = 'ai-planner';

export const PARENT_PRODUCT_MODULE_NAME: any = 'parentProduct';

export const MAX_SELECTED_TEXT_LENGTH = 20_000;

export type SendToParentProductPayload =
	| {
			contentId: string;
			contentType?: 'page' | 'blogpost' | 'whiteboard';
			eventType: 'embedded-confluence.text-selection.changed';
			selectedText: string;
			selectionLocalIds?: string[];
			sourceTitle?: string;
			sourceUrl?: string;
	  }
	| {
			contentId: string;
			eventType: 'embedded-confluence.text-selection.cleared';
	  };

/**
 * @deprecated Use `import { parseSendToParentProductPayload } from '@atlassian/embedded-confluence-common/parse-send-to-parent-product-payload'` instead.
 */
export { parseSendToParentProductPayload } from './parseSendToParentProductPayload';
/**
 * @deprecated Use `import { sendToParentProductFromEmbeddedConfluence } from '@atlassian/embedded-confluence-common/send-to-parent-product-from-embedded-confluence'` instead.
 */
export { sendToParentProductFromEmbeddedConfluence } from './sendToParentProductFromEmbeddedConfluence';
